import React from "react";
import ProfileDetails from "../admin/components/profile_page/ProfileDetails";

const ProfilePage = () => {
  return (
    <section className="p-4">
      <ProfileDetails />
    </section>
  );
};

export default ProfilePage;
